// @flow
import * as React from 'react';

// $FlowFixMe initialized with null, but we'll make sure there's always a real context
export const ReactPageContext = React.createContext<PageContext>(null);
